import { defineStore } from "pinia"
import { usarListarAtividadesStore } from "@/store/atividades/ListarAtividades/ListarAtividades.store"
import { usarFiltrosDoCalendarioStore } from "@/store/atividades/filtrosDoCalendario/filtrosDoCalendario.store"
import type { AtividadesParams } from "@/repositorios/atividades/atividades.modelos"
import { usarOcorrenciasDoCalendarioStore } from "../ocorrencias/ocorrencias.store"


export const usarCalendarioStore = defineStore("calendarioDeAtividades", {
  actions: {
    async montarCalendarioDeAtividades(parametros: AtividadesParams = { "por-pagina": "1000" }, utilizarCache = true) {
      const atividadesStore = usarListarAtividadesStore()
      const filtrosStore = usarFiltrosDoCalendarioStore()
      const ocorrenciasStore = usarOcorrenciasDoCalendarioStore()

      const deveFiltrarLocalmente = filtrosStore.possuiFiltroSelecionado || ocorrenciasStore.possuiOcorrenciaSelecionada

      await atividadesStore.verTodasAsAtividades(parametros, utilizarCache)
      await filtrosStore.extrairFiltrosAPartirDeEventos(atividadesStore.atividadesRequisitadas)

      if (deveFiltrarLocalmente) {
        await this.atualizarCalendarioLocalmente()
      }
    },
    async atualizarCalendarioLocalmente() {
      const filtrosStore = usarFiltrosDoCalendarioStore()
      const atividadesStore = usarListarAtividadesStore()

      const atividadesFiltradas = await filtrosStore.filtrarCalendario(atividadesStore.atividadesRequisitadas)
      atividadesStore.atividades = atividadesFiltradas

    }
  }
})
